import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiEnvelope } from '../../helpers/api-envelope.helper';
import { AdminSettings, AdminSettingsResponse } from '../../models/admin/admin-settings.model';
@Injectable({
  providedIn: 'root',
})
export class AdminSettingsService {
  constructor(private http: HttpClient) {}

  getSettings(): Observable<AdminSettings> {
    return this.http
      .get<AdminSettingsResponse | ApiEnvelope<AdminSettingsResponse>>(environment.apiUrl + '/admin/settings')
      .pipe(map((res) => ('data' in res ? res.data : res).settings));
  }

  updateSettings(payload: AdminSettings): Observable<AdminSettings> {
    return this.http
      .put<AdminSettingsResponse | ApiEnvelope<AdminSettingsResponse>>(environment.apiUrl + '/admin/settings', payload)
      .pipe(map((res) => ('data' in res ? res.data : res).settings));
  }
}
